/* ============================================================
   artvision® · Künstler-Bewerbung · Strecke
   Figma 417:102 ff. · Handoff 430:2

   - Acht Schritte + Zusammenfassung als Fläche über der Seite.
   - Pflicht nur: Vorname, Nachname, E-Mail (01), Medium (03),
     Modell (08), Datenschutz (Zusammenfassung). Optionalfelder
     blockieren nie.
   - Es wird nichts gespeichert: Wer die Seite verlässt oder neu
     lädt, beginnt leer. (Bewusst gegen den Entwurf im Handoff.)
   - Absenden als multipart an data-api, danach Calendly mit
     Name und E-Mail vorbelegt.
   - Analytics: Ereignisse gehen an window.dataLayer, wenn
     vorhanden. Freitexte werden nie übergeben.
   ============================================================ */

(function () {
  'use strict';

  var root = document.querySelector('[data-av-ap]');
  if (!root) return;

  var TOTAL = 8;                       // Zähler zeigt 01–08, Zusammenfassung = 08 / 08
  var MAX_FILES = 5;
  var MAX_BYTES = 10 * 1024 * 1024;

  var form = root.querySelector('[data-av-ap-form]');
  var scroller = root.querySelector('[data-av-ap-scroll]') || form;
  var steps = Array.prototype.slice.call(root.querySelectorAll('.av-ap__step'));
  var elCount = root.querySelector('[data-av-ap-count]');
  var elProgress = root.querySelector('[data-av-ap-progress]');
  var btnBack = root.querySelector('[data-av-ap-back]');
  var btnNext = root.querySelector('[data-av-ap-next]');
  var nextLabel = root.querySelector('[data-av-ap-next-label]');
  var after = root.querySelector('[data-av-ap-after]');
  var summary = root.querySelector('[data-av-ap-summary]');
  var errorBox = root.querySelector('[data-av-ap-error]');
  var done = root.querySelector('[data-av-ap-done]');
  var fileInput = root.querySelector('[data-av-ap-files]');
  var fileList = root.querySelector('[data-av-ap-filelist]');
  var fileErr = root.querySelector('[data-av-ap-file-err]');
  var api = root.getAttribute('data-api') || '';
  var LABEL_NEXT = (btnNext.getAttribute('data-label-next') || 'Weiter') + '  →';
  var LABEL_SUBMIT = (btnNext.getAttribute('data-label-submit') || 'Bewerbung absenden') + '  →';
  var LABEL_SUMMARY = (btnNext.getAttribute('data-label-summary') || 'Zur Übersicht') + '  →';

  var index = 0;
  var returnToSummary = false;
  var opener = null;
  var stepStart = Date.now();

  /* ---------- Beschriftungen für die Zusammenfassung ---------- */

  function labelsFor(key) {
    var map = {};
    Array.prototype.forEach.call(form.querySelectorAll('[data-av-ap-key="' + key + '"]'), function (input) {
      var label = input.closest('.av-ap-opt').querySelector('.av-ap-opt__label');
      map[input.value] = label ? label.textContent.trim() : input.value;
    });
    return map;
  }

  /* ---------- Analytics ---------- */

  var utm = {};
  try {
    var qs = new URLSearchParams(window.location.search);
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) {
      if (qs.get(k)) utm[k] = qs.get(k);
    });
  } catch (e) { /* ohne UTM */ }

  function track(event, extra) {
    if (!window.dataLayer || typeof window.dataLayer.push !== 'function') return;
    var step = steps[index];
    var payload = {
      event: event,
      package_interest: value('package') || undefined,
      billing_interval: value('billing_interval') || undefined,
      step: step ? Number(step.getAttribute('data-step')) : undefined,
      step_name: step ? step.getAttribute('data-name') : undefined,
      source: window.location.pathname
    };
    Object.keys(utm).forEach(function (k) { payload[k] = utm[k]; });
    if (extra) Object.keys(extra).forEach(function (k) { payload[k] = extra[k]; });
    window.dataLayer.push(payload);
  }

  /* ---------- Werte lesen und schreiben ---------- */

  function value(name) {
    var els = form.querySelectorAll('[name="' + name + '"]');
    if (!els.length) return '';
    if (els[0].type === 'radio') {
      var checked = form.querySelector('[name="' + name + '"]:checked');
      return checked ? checked.value : '';
    }
    return (els[0].value || '').trim();
  }

  function values(name) {
    return Array.prototype.map.call(form.querySelectorAll('[name="' + name + '[]"]:checked'), function (el) { return el.value; });
  }

  function collect() {
    var data = {};
    Array.prototype.forEach.call(form.elements, function (el) {
      if (!el.name || el.type === 'file' || el.name === 'fax') return;
      if (el.type === 'radio') { if (el.checked) data[el.name] = el.value; return; }
      if (el.type === 'checkbox') {
        if (el.name.slice(-2) === '[]') {
          var k = el.name.slice(0, -2);
          data[k] = data[k] || [];
          if (el.checked) data[k].push(el.value);
        } else {
          data[el.name] = el.checked;
        }
        return;
      }
      data[el.name] = el.value;
    });
    return data;
  }

  function apply(data) {
    Object.keys(data || {}).forEach(function (name) {
      var v = data[name];
      if (Array.isArray(v)) {
        Array.prototype.forEach.call(form.querySelectorAll('[name="' + name + '[]"]'), function (el) {
          el.checked = v.indexOf(el.value) !== -1;
        });
        return;
      }
      var els = form.querySelectorAll('[name="' + name + '"]');
      Array.prototype.forEach.call(els, function (el) {
        if (el.type === 'radio') el.checked = el.value === v;
        else if (el.type === 'checkbox') el.checked = !!v;
        else if (el.type !== 'file') el.value = v;
      });
    });
  }

  /* ---------- Kein Zwischenspeichern ----------
     Ältere Entwürfe aus einer früheren Fassung werden entfernt. */

  try { localStorage.removeItem('av:apply:v1'); } catch (e) { /* egal */ }
  function saveDraft() {}
  function clearDraft() {}

  /* ---------- Paket aus der Adresse ---------- */

  var PACKAGE_LABELS = { standard: 'STANDARD', academy: 'ACADEMY', elite: 'ELITE', undecided: 'noch offen' };

  /* Das Paket, das jemand vorher angeklickt hat (Paketkarte, Paketseite),
     kommt als ?package_interest= mit. Fehlt es in der Adresse, gilt das
     zuletzt angeklickte Paket dieser Sitzung (siehe layout/theme.liquid).
     Gespeichert wird nur diese Wahl, keine Eingaben. */
  var PKG_KEY = 'av:apply:package';

  function packageFromUrl() {
    var p = '';
    try { p = (new URLSearchParams(window.location.search).get('package_interest') || '').toLowerCase(); } catch (e) { p = ''; }
    if (!PACKAGE_LABELS[p]) {
      try { p = (window.sessionStorage.getItem(PKG_KEY) || '').toLowerCase(); } catch (e) { p = ''; }
    }
    return PACKAGE_LABELS[p] ? p : '';
  }

  /* ---------- Zahlweise aus der Adresse (KV-04) ----------
     ?billing=yearly|monthly von „Kunst verkaufen“ bzw. der Paketseite,
     sonst die Wahl dieser Sitzung (assets/av-billing.js). */
  function billingFromUrl() {
    var b = '';
    try { b = (new URLSearchParams(window.location.search).get('billing') || '').toLowerCase(); } catch (e) { b = ''; }
    if (b !== 'yearly' && b !== 'monthly') {
      try { b = window.sessionStorage.getItem('av:apply:billing') || ''; } catch (e) { b = ''; }
    }
    return b === 'yearly' || b === 'monthly' ? b : '';
  }

  /* ---------- Prüfen ---------- */

  function setError(field, on) {
    var wrap = field.closest('.av-ap-f, .av-ap-group');
    if (!wrap) return;
    var err = wrap.querySelector('.av-ap-f__err');
    if (field.matches('input, textarea')) field.setAttribute('aria-invalid', on ? 'true' : 'false');
    if (wrap.classList.contains('av-ap-group')) wrap.setAttribute('aria-invalid', on ? 'true' : 'false');
    if (err) err.hidden = !on;
  }

  // Mindestens 6 Ziffern, sonst nur Leerzeichen, + ( ) / . - erlaubt.
  function isValidPhone(v) {
    return /^[0-9+()\/.\s-]+$/.test(v) && v.replace(/\D/g, '').length >= 6;
  }

  function validate(step) {
    var first = null;

    Array.prototype.forEach.call(step.querySelectorAll('input[required]'), function (input) {
      var v = input.value.trim();
      var ok = v !== ''
        && (input.type !== 'email' || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v))
        && (input.type !== 'tel' || isValidPhone(v));
      setError(input, !ok);
      if (!ok && !first) first = input;
    });

    Array.prototype.forEach.call(step.querySelectorAll('[data-required]'), function (group) {
      var ok = !!value(group.getAttribute('data-required'));
      setError(group, !ok);
      if (!ok && !first) first = group.querySelector('input');
    });

    if (step.getAttribute('data-step') === '9') {
      var consent = form.querySelector('[data-av-ap-consent]');
      var consentErr = root.querySelector('[data-av-ap-consent-err]');
      var ok = consent.checked;
      consentErr.hidden = ok;
      if (!ok && !first) first = consent;
    }

    if (first) {
      first.focus({ preventScroll: false });
      track('application_error', { field: first.name || '' });
    }
    return !first;
  }

  form.addEventListener('input', function (event) {
    var t = event.target;
    if (t.getAttribute('aria-invalid') === 'true' && t.value.trim()) setError(t, false);
    saveDraft();
  });

  form.addEventListener('change', function (event) {
    var t = event.target;
    var group = t.closest('.av-ap-group[aria-invalid="true"]');
    if (group) setError(group, false);
    if (t.hasAttribute('data-av-ap-consent') && t.checked) root.querySelector('[data-av-ap-consent-err]').hidden = true;
    saveDraft();
  });

  /* ---------- Dateien ---------- */

  function renderFiles() {
    if (!fileInput) return;
    fileList.innerHTML = '';
    fileErr.hidden = true;
    var files = Array.prototype.slice.call(fileInput.files || []);
    var problem = '';
    if (files.length > MAX_FILES) problem = 'Bitte wähle höchstens ' + MAX_FILES + ' Fotos.';
    files.forEach(function (f) {
      if (!/\.(pdf|jpe?g|png)$/i.test(f.name)) problem = 'Bitte nur Fotos (JPG, PNG) oder PDF auswählen.';
      else if (f.size > MAX_BYTES) problem = '„' + f.name + '“ ist zu groß (über 10 MB). Nimm einfach ein anderes Foto oder zeig uns deine Arbeiten im Gespräch.';
      var li = document.createElement('li');
      li.className = 'av-ap-upload__item';
      if (/\.(jpe?g|png)$/i.test(f.name) && window.URL && URL.createObjectURL) {
        var img = document.createElement('img');
        img.className = 'av-ap-upload__thumb';
        img.alt = f.name;
        img.src = URL.createObjectURL(f);
        img.onload = function () { URL.revokeObjectURL(img.src); };
        li.appendChild(img);
      } else {
        var doc = document.createElement('span');
        doc.className = 'av-ap-upload__doc';
        doc.textContent = f.name;
        li.appendChild(doc);
      }
      fileList.appendChild(li);
    });
    if (problem) {
      fileErr.textContent = problem;
      fileErr.hidden = false;
      fileInput.value = '';
      fileList.innerHTML = '';
    }
  }
  if (fileInput) fileInput.addEventListener('change', renderFiles);

  /* ---------- Zusammenfassung ---------- */

  function joinLabels(key, list) {
    var map = labelsFor(key);
    return list.map(function (v) { return map[v] || v; }).join(' · ');
  }

  function one(key) {
    var v = value(key);
    return v ? (labelsFor(key)[v] || v) : '';
  }

  function short(text, n) {
    text = (text || '').replace(/\s+/g, ' ').trim();
    return text.length > n ? text.slice(0, n - 1) + '…' : text;
  }

  function renderSummary() {
    var files = fileInput && fileInput.files ? fileInput.files.length : 0;
    var rows = [
      ['Person', 1, [[value('first_name'), value('last_name')].join(' ').trim(), value('email'), value('phone'), value('city')]],
      ['Online-Präsenz', 2, [value('instagram'), value('website'), value('portfolio_url'), value('other_channels')]],
      ['Deine Kunst', 3, [one('medium'), short(value('about'), 60), files ? files + (files === 1 ? ' Datei' : ' Dateien') : '']],
      ['Erfahrung', 4, [joinLabels('experience', values('experience')), one('sales_frequency')]],
      ['Herausforderung', 5, [joinLabels('challenges', values('challenges')), value('challenges_other')]],
      ['Ziele', 6, [short(value('goals'), 60), one('timeline')]],
      ['Dein Rahmen', 7, [one('investment_readiness'), one('budget_band')]],
      ['Interesse', 8, [one('package'), value('artvision_interest') ? 'ART VISION: ' + one('artvision_interest') : '']]
    ];

    summary.innerHTML = '';
    rows.forEach(function (row) {
      var text = row[2].filter(Boolean).join(' · ');
      // Leere Zeilen weglassen: viele „Keine Angabe“ wirken wie Lücken.
      if (!text) return;
      var wrap = document.createElement('div');
      wrap.className = 'av-ap-sum__row';
      var dt = document.createElement('dt');
      dt.textContent = row[0];
      var dd = document.createElement('dd');
      dd.textContent = text;
      var edit = document.createElement('button');
      edit.type = 'button';
      edit.className = 'av-ap-sum__edit';
      edit.textContent = 'Ändern';
      edit.setAttribute('aria-label', row[0] + ' ändern');
      edit.setAttribute('data-goto', String(row[1]));
      wrap.appendChild(dt);
      wrap.appendChild(dd);
      wrap.appendChild(edit);
      summary.appendChild(wrap);
    });
  }

  summary.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-goto]');
    if (!btn) return;
    returnToSummary = true;
    show(Number(btn.getAttribute('data-goto')) - 1);
  });

  /* ---------- Navigation ---------- */

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function show(i) {
    index = Math.max(0, Math.min(steps.length - 1, i));
    steps.forEach(function (s, n) { s.hidden = n !== index; });

    var isSummary = index === steps.length - 1;
    var shown = Math.min(index + 1, TOTAL);
    elCount.textContent = pad(shown) + ' / ' + pad(TOTAL);
    elProgress.style.width = (shown / TOTAL) * 100 + '%';

    btnBack.hidden = index === 0;
    nextLabel.textContent = isSummary ? LABEL_SUBMIT : (returnToSummary ? LABEL_SUMMARY : LABEL_NEXT);
    after.hidden = !isSummary;
    if (errorBox) errorBox.hidden = true;
    if (isSummary) { returnToSummary = false; renderSummary(); }
    if (index >= 1) preloadCalendly();

    scroller.scrollTop = 0;
    var q = steps[index].querySelector('.av-ap__q');
    if (q) q.focus({ preventScroll: true });

    stepStart = Date.now();
    track('application_step_view');
    saveDraft();
  }

  function next() {
    var step = steps[index];
    if (!validate(step)) return;
    track('application_step_complete', { duration_s: Math.round((Date.now() - stepStart) / 1000) });
    if (index === steps.length - 1) return submit();
    if (returnToSummary) return show(steps.length - 1);
    show(index + 1);
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    next();
  });

  btnBack.addEventListener('click', function () {
    track('application_back');
    show(index - 1);
  });

  /* ---------- Absenden ---------- */

  function busy(on) {
    btnNext.disabled = on;
    nextLabel.textContent = on ? 'Wird gesendet …' : LABEL_SUBMIT;
  }

  function showError(text) {
    errorBox.textContent = text;
    errorBox.hidden = false;
  }

  function calendlyUrl(base, data) {
    try {
      var url = new URL(base);
      var name = [data.first_name, data.last_name].join(' ').trim();
      if (name) url.searchParams.set('name', name);
      if (data.email) url.searchParams.set('email', data.email);
      return url.toString();
    } catch (e) { return base; }
  }

  /* Nur wer ausdrücklich STANDARD wählt, sieht nach dem Absenden zuerst den
     Weg zu STANDARD statt des Kalenders. Knappes Budget allein reicht nicht:
     In Tests waren genau diese Leute oft technikfern und wollten zuerst
     sprechen. STANDARD + fast monatliche Verkäufe oder Rahmen ab 150 € →
     Gespräch (ACADEMY kann passen). Der Kalender bleibt immer erreichbar. */
  function wantsStandard() {
    var budget = value('budget_band');
    if (value('package') !== 'standard') return false;
    var freq = value('sales_frequency');
    var strong = freq === 'regular' || freq === 'monthly' || budget === '150_250' || budget === 'over_250';
    return !strong;
  }

  /* Calendly als Inline-iframe (ohne widget.js). Name/E-Mail vorbelegt,
     Höhe folgt der Nachricht calendly.page_height, Buchung wird getrackt. */
  var calSrc = '';
  function mountCalendly(base, data) {
    var box = done.querySelector('[data-av-ap-cal]');
    if (!box || !base) return;
    var src = calendlyUrl(base, data);
    try {
      var u = new URL(src);
      u.searchParams.set('embed_domain', window.location.hostname);
      u.searchParams.set('embed_type', 'Inline');
      u.searchParams.set('hide_gdpr_banner', '1');
      // Ruhig und markenneutral: Akzent Schwarz statt Coral, linke
      // Event-Spalte aus (Titel und Dauer stehen schon in der Überschrift).
      u.searchParams.set('hide_event_type_details', '1');
      u.searchParams.set('background_color', 'ffffff'); // = --ap-card, weiße Kalender-Karte
      u.searchParams.set('text_color', '111111');
      u.searchParams.set('primary_color', '111111');
      src = u.toString();
    } catch (e) { /* Link bleibt wie er ist */ }
    if (src === calSrc) return; // schon (vor)geladen
    calSrc = src;
    var old = box.querySelector('iframe');
    if (old) old.parentNode.removeChild(old);
    box.classList.add('is-loading');
    var frame = document.createElement('iframe');
    frame.src = src;
    frame.title = 'Termin wählen';
    frame.loading = 'eager';
    frame.setAttribute('frameborder', '0');
    frame.addEventListener('load', function () {
      // Calendly zeichnet nach dem load noch kurz nach; spätestens dann weg mit dem Hinweis.
      setTimeout(function () { box.classList.remove('is-loading'); }, 1200);
    });
    box.appendChild(frame);
  }

  /* Kalender schon während der Strecke unsichtbar vorladen (sobald Name und
     E-Mail feststehen), damit er nach dem Absenden sofort fertig dasteht. */
  function calendlyBase() {
    var link = done.querySelector('[data-av-ap-calendly]');
    return root.getAttribute('data-calendly') || (link && link.getAttribute('href')) || '';
  }
  function preloadCalendly() {
    var d = collect();
    if (!d.email || !/@/.test(d.email)) return;
    mountCalendly(calendlyBase(), d);
  }

  window.addEventListener('message', function (e) {
    if (!/calendly\.com$/.test((function () { try { return new URL(e.origin).hostname; } catch (x) { return ''; } })())) return;
    var d = e.data || {};
    var box = done.querySelector('[data-av-ap-cal]');
    if (d.event === 'calendly.page_height' && d.payload && d.payload.height && box) {
      var h = parseInt(d.payload.height, 10);
      // Beim unsichtbaren Vorladen ist die Höhe nicht verlässlich (Breite 0) – nur sichtbar übernehmen.
      if (h > 300 && box.offsetParent !== null) box.style.height = h + 'px';
      box.classList.remove('is-loading');
    }
    if (d.event === 'calendly.event_type_viewed' && box) box.classList.remove('is-loading');
    if (d.event === 'calendly.date_and_time_selected') track('calendly_booking_start');
    if (d.event === 'calendly.event_scheduled') track('calendly_booking_complete');
  });

  /* Nach dem Absenden ist die Strecke keine Fläche mehr über der Seite,
     sondern normaler Seiteninhalt zwischen Kopfzeile und Footer. */
  function showDoneInPage() {
    root.classList.add('av-ap--done');
    root.style.top = '';
    root.removeAttribute('role');
    root.removeAttribute('aria-modal');
    document.documentElement.classList.remove('av-ap-is-open');
    document.documentElement.classList.add('av-ap-is-done');
    window.scrollTo(0, 0);
  }

  function mountDoneVideo() {
    var v = done.querySelector('[data-av-ap-done-video]');
    if (!v) return;
    if (v.hasAttribute('data-autoplay')) { embedVideo(v, true); return; }
    var btn = v.querySelector('[data-av-ap-play]');
    if (btn) btn.addEventListener('click', function () { embedVideo(v, false); });
  }

  function submit() {
    if (!api) {
      showError('Das Formular ist noch nicht angebunden. Schreib uns gern über die Kontaktseite.');
      return;
    }

    var data = collect();
    var body = new FormData();
    Object.keys(data).forEach(function (k) {
      var v = data[k];
      if (Array.isArray(v)) v.forEach(function (item) { body.append(k + '[]', item); });
      else if (typeof v === 'boolean') body.append(k, v ? '1' : '');
      else body.append(k, v);
    });
    body.append('discipline', data.medium || '');
    body.append('fax', (form.querySelector('[name="fax"]') || {}).value || '');
    body.append('source', window.location.origin + window.location.pathname);
    Object.keys(utm).forEach(function (k) { body.append(k, utm[k]); });
    Array.prototype.forEach.call((fileInput && fileInput.files) || [], function (f) { body.append('files[]', f); });

    busy(true);
    track('application_submit');

    fetch(api, { method: 'POST', headers: { Accept: 'application/json' }, body: body })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (json) { return { status: res.status, body: json }; });
      }, function () {
        /* Nur echte Netzwerk-/CORS-Fehler landen hier, nicht Fehler beim Anzeigen der Bestätigung. */
        return { status: 0, body: {} };
      })
      .then(function (result) {
        if (result.status === 0) return showError('Keine Verbindung. Bitte prüf deine Internetverbindung und versuch es noch einmal.');
        if (result.status === 200 || result.status === 201) {
          clearDraft();
          var link = done.querySelector('[data-av-ap-calendly]');
          var calBase = calendlyBase();
          if (link) {
            link.href = calendlyUrl(calBase, data);
            link.addEventListener('click', function () { track('calendly_booking_start'); }, { once: true });
          }
          mountCalendly(calBase, data);
          mountDoneVideo();
          form.hidden = true;
          done.hidden = false;
          showDoneInPage();
          elCount.textContent = '';
          elProgress.style.width = '100%';
          var stdBand = done.querySelector('[data-av-ap-std]');
          var calBand = done.querySelector('[data-av-ap-cal-band]');
          var toStandard = !!stdBand && wantsStandard();
          if (stdBand) stdBand.hidden = !toStandard;
          if (calBand) calBand.hidden = toStandard;
          var h = done.querySelector(toStandard ? '[data-av-ap-std-heading]' : '[data-av-ap-done-heading]');
          if (h) h.focus({ preventScroll: true });
          track('application_success_view', { route: toStandard ? 'standard' : 'call' });
          return;
        }
        if (result.status === 422 && result.body && result.body.errors) {
          var keys = Object.keys(result.body.errors);
          showError('Bitte prüf deine Angaben: ' + keys.join(', ') + '.');
          track('application_error', { field: keys[0] || '' });
          return;
        }
        if (result.status === 429) return showError('Zu viele Versuche in kurzer Zeit. Bitte versuch es in einer Minute noch einmal.');
        showError('Die Bewerbung konnte gerade nicht gesendet werden. Bitte versuch es später noch einmal oder schreib uns über die Kontaktseite.');
      })
      .catch(function (err) {
        if (window.console) console.error('[av-apply] Fehler nach dem Absenden', err);
      })
      .then(function () { btnNext.disabled = false; if (!form.hidden) busy(false); });
  }

  /* ---------- Öffnen und Schließen ---------- */

  /* Wie im Art Finder: Die Strecke beginnt unter der Navigation. */
  function headerBottom() {
    var nodes = document.querySelectorAll('[data-av-header], .shopify-section-group-header-group');
    var bottom = 0;
    Array.prototype.forEach.call(nodes, function (el) {
      if (root.contains(el)) return;
      var r = el.getBoundingClientRect();
      if (r.height > 0) bottom = Math.max(bottom, r.bottom);
    });
    return Math.max(0, Math.round(bottom));
  }

  function placeBelowHeader() { root.style.top = headerBottom() + 'px'; }

  var savedScroll = 0;

  function open(trigger) {
    if (!root.hidden) return;
    opener = trigger || null;
    savedScroll = window.scrollY || 0;
    window.scrollTo(0, 0);
    root.hidden = false;
    document.documentElement.classList.add('av-ap-is-open');
    placeBelowHeader();
    try { window.history.pushState({ avApply: true }, '', window.location.href); } catch (e) { /* ohne */ }
    /* Jeder Start beginnt leer, nur das Paket aus der Adresse bleibt. */
    form.reset();
    if (fileList) fileList.innerHTML = '';
    if (pkg) apply({ package: pkg });
    track('application_start');
    show(0);
  }

  function close() {
    if (root.hidden) return;
    if (form.hidden === false && index > 0) track('application_abandon');
    root.hidden = true;
    document.documentElement.classList.remove('av-ap-is-open');
    window.scrollTo(0, savedScroll);
    if (window.history.state && window.history.state.avApply) {
      try { window.history.back(); } catch (e) { /* egal */ }
    }
    if (opener && document.contains(opener)) opener.focus({ preventScroll: true });
  }

  Array.prototype.forEach.call(root.querySelectorAll('[data-av-ap-cancel]'), function (btn) {
    btn.addEventListener('click', close);
  });
  window.addEventListener('resize', function () { if (!root.hidden && !isDone()) placeBelowHeader(); });
  root.addEventListener('keydown', function (event) { if (event.key === 'Escape' && !isDone()) close(); });
  function isDone() { return root.classList.contains('av-ap--done'); }
  window.addEventListener('popstate', function () {
    if (!root.hidden && !isDone()) {
      root.hidden = true;
      document.documentElement.classList.remove('av-ap-is-open');
      window.scrollTo(0, savedScroll);
    }
  });

  document.addEventListener('click', function (event) {
    var start = event.target.closest('[data-av-ap-start]');
    if (!start) return;
    event.preventDefault();
    open(start);
  });

  /* ---------- Video (2-Klick) ---------- */

  var video = document.querySelector('[data-av-ap-video]');
  var play = video && video.querySelector('[data-av-ap-play]');
  function embedVideo(video, muted) {
    var id = video.getAttribute('data-youtube');
    if (!id) return;
    var frame = document.createElement('iframe');
    // cc_load_policy=1 + cc_lang_pref=de: Untertitel an. Autoplay ohne Klick
    // geht in Browsern nur stumm — mit Untertiteln bleibt es verständlich.
    frame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id)
      + '?autoplay=1&cc_load_policy=1&cc_lang_pref=de&hl=de&rel=0&playsinline=1&modestbranding=1'
      + (muted ? '&mute=1' : '');
    frame.title = 'Video';
    frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    frame.allowFullscreen = true;
    video.innerHTML = '';
    video.appendChild(frame);
  }

  if (video && video.hasAttribute('data-autoplay') && video.getAttribute('data-youtube')) {
    embedVideo(video, true);
  } else if (play) {
    play.addEventListener('click', function () { embedVideo(video, false); });
  }

  /* ---------- Abschluss: STANDARD-Weg ---------- */

  done.addEventListener('click', function (e) {
    if (e.target.closest('[data-av-ap-std-link]')) { track('standard_cta_click'); return; }
    var talk = e.target.closest('[data-av-ap-std-talk]');
    if (!talk) return;
    var calBand = done.querySelector('[data-av-ap-cal-band]');
    if (!calBand) return;
    calBand.hidden = false;
    talk.closest('p').hidden = true;
    track('standard_route_talk');
    calBand.scrollIntoView({ behavior: 'smooth', block: 'start' });
    var ch = calBand.querySelector('[data-av-ap-done-heading]');
    if (ch) ch.focus({ preventScroll: true });
  });

  /* ---------- Start ---------- */

  var pkg = packageFromUrl();
  if (pkg) apply({ package: pkg });
  var billing = billingFromUrl();
  apply({ billing_interval: billing || 'yearly' });
  form.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'billing_interval') {
      try { sessionStorage.setItem('av:apply:billing', e.target.value); } catch (err) { /* egal */ }
    }
  });

  var interest = document.querySelector('[data-av-ap-interest]');
  if (interest && (pkg || value('package'))) {
    interest.querySelector('[data-av-ap-interest-label]').textContent = PACKAGE_LABELS[pkg || value('package')];
    interest.hidden = false;
  }
})();
